import { render, staticRenderFns } from "./dashboard1.vue?vue&type=template&id=4869becb&scoped=true&"
import script from "./dashboard1.vue?vue&type=script&lang=js&"
export * from "./dashboard1.vue?vue&type=script&lang=js&"
import style0 from "./dashboard1.vue?vue&type=style&index=0&id=4869becb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4869becb",
  null
  
)

export default component.exports